import { load, save } from "./storage"
import { DELETED_CHAT_IDS } from "./storage-keys"

export async function getDeletedChatIds(): Promise<string[]> {
  const ids = await load(DELETED_CHAT_IDS)
  return Array.isArray(ids) ? (ids.filter((x) => typeof x === "string") as string[]) : []
}

export async function addDeletedChatId(chat_id: string): Promise<void> {
  if (!chat_id) return
  const ids = await getDeletedChatIds()
  if (!ids.includes(chat_id)) {
    ids.push(chat_id)
    await save(DELETED_CHAT_IDS, ids)
  }
}

export async function removeDeletedChatId(chat_id: string): Promise<void> {
  if (!chat_id) return
  const ids = await getDeletedChatIds()
  const next = ids.filter((id) => id !== chat_id)
  await save(DELETED_CHAT_IDS, next)
}

